import React from "react";
import moment from "moment";
import { enums } from "../../enums/"

import { CircularProgress } from "material-ui/Progress";
import { FiZapOff } from "react-icons/fi";
import { Typography } from "material-ui";
import { Bar } from "react-chartjs-2";
import { getColorsWithAlpha } from "../../constants/Colors";
//import { BarChartCardContent } from "./BarChartCardContent";

export class BarChart extends React.Component {
  
  render() {
    const {
      classes,
      unit,
      stacked,
      loading,
      barChartData,
      t,
      i18n,
      dateDisplayOptions
    } = this.props;

    if (loading || !barChartData) {
      return <CircularProgress size={24} className={classes.buttonProgress} />;
    }

    if (barChartData.data.length <= 0) {
      return (
        <Typography variant="body2" style={{ margin: 10, color: "#CECECE" }}>
          <FiZapOff style={{ position: "relative", top: 3, marginRight: 10 }} />
          {t("No data yet")}
        </Typography>
      );
    }



    let colorAlphaOfficialCertificates = 0.9;
    let colorAlphaLiveCertificates = 0.5;
    let colorAlphaBorder = 1;

    const backgroundColorsOfficialCertificates = getColorsWithAlpha(colorAlphaOfficialCertificates);
    const backgroundColorsLiveCertificates = getColorsWithAlpha(colorAlphaLiveCertificates);
    const borderColors = getColorsWithAlpha(colorAlphaBorder);

    const datasets = barChartData.data.map(
      (chartData, index) => {
        let backgroundColorArray = [];

        for (let i = 0; i < chartData.data.length; i++) {
          let status = barChartData.certificateStatusArray[i];
          let color;
          if (status && status === enums.CertificateStatus.LIVE) {
            color = backgroundColorsLiveCertificates[index];
          } else {
            color = backgroundColorsOfficialCertificates[index];
          }

          // Consumption data always official background color
          if (index >= barChartData.data.length - 1) {
            color = backgroundColorsOfficialCertificates[index];
          }

          backgroundColorArray.push(color);
        }

        let newDataset = {
          label: chartData.label,
          backgroundColor: backgroundColorArray,
          borderColor: borderColors[index],
          borderWidth: 1,
          hoverBackgroundColor: backgroundColorArray,
          hoverBorderColor: borderColors[index],
          data: chartData.data
        };

        if (index >= barChartData.data.length - 1) {
          newDataset.type = "line";
        }

        return newDataset;
      }
    );
    
    let dateFormat;
    if(dateDisplayOptions === "daily") {
      dateFormat = 'YYYY-MM-DD' //English date
      if(i18n.language === 'fr') {
        dateFormat = 'DD-MM-YYYY'
      } else if(i18n.language === 'en_us') {
        dateFormat = 'MM-DD-YYYY' //American date
      }
    } else if (dateDisplayOptions === "hourly") {
      dateFormat = 'YYYY-MM-DD HH:mm' //English date
      if(i18n.language === 'fr') {
        dateFormat = 'DD-MM-YYYY HH:mm'
      } else if(i18n.language === 'en_us') {
        dateFormat = 'MM-DD-YYYY h:mm a' //American date
      }
    }


    let labels = barChartData.labels.map(label => {
      return moment(label).format(dateFormat)
    })

    const data = {
      labels: labels,
      datasets
    };


    return (
      <Bar
        ref={ref => {
          this.chart = ref;
        }}
        data={data}
        width={1200}
        height={400}
        options={{
          elements: {
            point:{
                radius: 0
            }
          },
          maintainAspectRatio: false,
          responsive: true,
          scales: {
            xAxes: [
              {
                stacked
              }
            ],
            yAxes: [
              {
                stacked,
                ticks: {
                  callback: (value) => {
                    let valueDisplayed = "";
                    switch (unit) {
                      case false:
                        valueDisplayed = "";
                        break;
                      case enums.Unit.KWH:
                        valueDisplayed = Math.round(value).toLocaleString();
                        break;
                        case enums.Unit.MWH:
                        valueDisplayed = Math.round(
                          value / 1000
                        ).toLocaleString();
                        break;
                      default:
                        valueDisplayed = "";
                    }
                    return valueDisplayed;
                  }
                }
              }
            ]
          },
          legend: {
            display: false
          },
          tooltips: {
            intersect: false,
            mode: "index",
            filter: (tooltipItem) => {
              return parseFloat(tooltipItem.yLabel) > 0
            },
            callbacks: {
              title: (tooltipItem, chartData) => {
                if (tooltipItem[0]) {
                  let firstData = tooltipItem[0];
                  let status = barChartData.certificateStatusArray[firstData.index];
                  if (status === "live") {
                    return "LIVE - " + firstData.label;
                  } else {
                    return firstData.label;
                  }
                } else {
                  return null;
                }
              },
              label: (tooltipItem, data) => {
                let dataDisplayed = "";
                switch (unit) {
                  case false:
                    dataDisplayed = "";
                    break;
                  case enums.Unit.KWH:
                    dataDisplayed =
                      Math.round(tooltipItem.yLabel).toLocaleString() + " " + enums.Unit.KWH;
                    break;
                  case enums.Unit.MWH:
                    dataDisplayed =
                      Math.round(tooltipItem.yLabel / 1000).toLocaleString() +
                      " " + enums.Unit.MWH;
                    break;
                  default:
                    dataDisplayed = "";
                }

                dataDisplayed = data.datasets[tooltipItem.datasetIndex].label + ' : ' + dataDisplayed;

                return dataDisplayed;
              },
              labelColor: (tooltipItem, chart) => {
                let color = backgroundColorsOfficialCertificates[tooltipItem.datasetIndex];
                return {
                  borderColor: color,
                  backgroundColor: color
                }
              }
            }
          }
        }}
      />   
    );

    
  }
}


// WEBPACK FOOTER //
// ./src/components/ChartCards/BarChart.js